<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left>mdi-folder</v-icon>
        {{ isNew ? 'Add Subcategory' : 'Edit Subcategory' }}
        <v-spacer></v-spacer>
        <v-btn icon color="white" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-alert 
          v-if="isNew" 
          type="info" 
          text 
          class="mb-4"
        >
          <strong>Creating a new subcategory?</strong> Subcategories help organize products within a category. You can add products to this subcategory after creating it.
        </v-alert>
        
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="editedSubcategory.name"
            label="Subcategory Name"
            :rules="[v => !!v || 'Subcategory name is required']"
            required
            outlined
            placeholder="Enter subcategory name"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn 
          color="primary" 
          @click="save" 
          :disabled="!valid"
          :loading="saving"
        >
          {{ isNew ? 'Add' : 'Save' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditSubcategoryDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    subcategory: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      valid: false,
      saving: false,
      editedSubcategory: {}
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isNew() {
      return !this.subcategory || !this.subcategory._id
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.editedSubcategory = { 
          ...this.subcategory,
          products: this.subcategory.products || []
        }
      }
    }
  },
  methods: {
    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true
        try {
          await this.$emit('save', { ...this.editedSubcategory })
        } finally {
          this.saving = false
        }
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script> 